import corner1 from '@/assets/img/icons/spot-illustrations/corner-1.png';
import corner3 from '@/assets/img/icons/spot-illustrations/corner-3.png';
import corner2 from '@/assets/img/icons/spot-illustrations/corner-2.png';
import URLRenderer from '@/app/common/components/CellRenderers/URLRenderer';
import IconWithLabel from './IconWithLabel';
import Background from '@/components/common/Background';
import { Card, Col, Row } from 'react-bootstrap';
import {
  breakpointsMediaQuery,
  getColor,
  useMediaQuery
} from '@/helpers/utils';
import type { ReactElement, ReactNode } from 'react';

const SimpleURLRenderer = URLRenderer as (props: {
  url?: string | null;
  enableCopyAndRedirect?: boolean;
}) => ReactElement;

export type OverviewCardsProps = {
  title?: ReactNode;
  description?: ReactNode;
  robotsFileUrl?: string;
  robotsTag?: ReactNode;
  canonical?: string;
  keywords?: ReactNode;
  langauge?: ReactNode;
  word_count?: ReactNode;
  url?: string;
  sentences_count?: ReactNode;
  estimated_time?: ReactNode;
  publisher?: ReactNode;
};

const OverviewCards = ({
  title,
  description,
  robotsFileUrl,
  robotsTag,
  canonical,
  keywords,
  langauge,
  word_count,
  url,
  sentences_count,
  estimated_time,
  publisher
}: OverviewCardsProps) => {
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);
  return (
    <>
      <Card className="h-100 my-3 overflow-hidden">
        <Background image={corner3} className="rounded-soft bg-card" />
        <Card.Body className="z-1">
          <Row className="g-3 h-100 align-items-end">
            <IconWithLabel
              title="تگ عنوان"
              md={12}
              sm={12}
              xs={12}
              color={getColor('navbar-vertical-default-link-active-color')}
              icon="heading"
              text={title}
            />
            <IconWithLabel
              title="توضیح متا"
              md={12}
              sm={12}
              xs={12}
              color={getColor('navbar-vertical-default-link-active-color')}
              icon="file-lines"
              text={description}
            />
          </Row>
        </Card.Body>
      </Card>
      <Row className="g-3 my-3">
        <Col xl={8} lg={12}>
          <Card className="h-100 overflow-hidden">
            <Background image={corner1} className="rounded-soft bg-card" />
            <Card.Body className="z-1">
              <Row className="g-3 h-100 align-items-end">
                <IconWithLabel
                  title="نشانی"
                  md={12}
                  sm={12}
                  xs={12}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="link"
                  text={<SimpleURLRenderer enableCopyAndRedirect url={url} />}
                />
                <IconWithLabel
                  title="کنونیکال"
                  md={12}
                  sm={12}
                  xs={12}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="circle-dot"
                  text={<SimpleURLRenderer url={canonical} />}
                />
                <IconWithLabel
                  title="تگ robots"
                  md={12}
                  sm={12}
                  xs={12}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="tag"
                  text={robotsTag}
                />

                <IconWithLabel
                  title="Robots.txt"
                  md={12}
                  sm={12}
                  xs={12}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="robot"
                  text={<SimpleURLRenderer url={robotsFileUrl} />}
                />
              </Row>
            </Card.Body>
          </Card>
        </Col>
        <Col xl={4} lg={12}>
          <Card className="h-100 overflow-hidden">
            <Background image={corner2} className="rounded-soft bg-card" />
            <Card.Body className="z-1">
              <Row className="g-3 h-100 align-items-end">
                <IconWithLabel
                  title="تگ کیورد"
                  md={6}
                  sm={6}
                  xs={6}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="bolt"
                  text={keywords}
                />
                <IconWithLabel
                  title="زبان"
                  md={6}
                  sm={6}
                  xs={6}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="language"
                  text={langauge}
                />
                <IconWithLabel
                  title="تعداد کلمات"
                  md={6}
                  sm={6}
                  xs={6}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="rectangle-list"
                  text={word_count}
                />
                <IconWithLabel
                  title="تعداد جملات"
                  md={6}
                  sm={6}
                  xs={6}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="rectangle-list"
                  text={sentences_count}
                />
                <IconWithLabel
                  title={isMdUp ? 'زمان تقریبی مطالعه' : 'مطالعه'}
                  md={6}
                  sm={6}
                  xs={6}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="clock"
                  text={estimated_time}
                />
                <IconWithLabel
                  title="ناشر"
                  md={6}
                  sm={6}
                  xs={6}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="upload"
                  text={publisher}
                />
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default OverviewCards;
